const EFFECTS = {
  boxShadow: {
    button: '0 0.625rem 0.9375rem #00000033',
    cards: '0 0.25rem 0.9375rem #00000033',
  },
};

export default EFFECTS;
